import {
    Vue, Component, Prop,
} from 'vue-property-decorator';

/**
 * Common Props
 */
@Component
class Props extends Vue {
    /**
     * Base Class of the component
     */
    @Prop() baseClass!: string;

    /**
     * Content
     */
    @Prop() content!: string;

    /**
     * Color
     * 
     * The accepted values can be changed via the colors map
     * 
     * @values "primary", "secondary", "success", "info", "warning", "danger", "link"
     */
    @Prop({ default: 'default' }) color!: string;

    /**
     * Size
     * 
     * The accepted values can be changed via the sizes map
     * 
     * @values "xtiny", "tiny", "mini", "xsmall", "small", "normal", "medium", "large", "xlarge"
     */
    @Prop({ default: 'normal' }) size!: string;

    /**
     * Icon
     */
    @Prop() icon!: string;

    /**
     * Remove border radius from the component
     */
    @Prop({ type: Boolean }) sharp!: boolean;

    /**
     * Make the component rounded (Default)
     */
    @Prop({ type: Boolean }) rounded!: boolean;

    /**
     * Remove the shadow of the button (Default)
     */
    @Prop({ type: Boolean }) flat!: boolean;

    /**
     * Add Shadow to the component
     */
    @Prop({ type: Boolean }) raised!: boolean;

    /**
     * Add more border radius to the component
     */
    @Prop({ type: Boolean }) pill!: boolean;

    /**
     * Make the component outline
     */
    @Prop({ type: Boolean }) outline!: boolean;

    /**
     * Add Border to the alert (Default)
     */
    @Prop({ type: Boolean }) bordered!: boolean;

    /**
     * Set block component
     */
    @Prop({ type: Boolean }) block!: boolean;

    /**
     * Reduce size
     */
    @Prop({ type: Boolean }) dense!: boolean;
}

export default Props;
